import { ButtonHTMLAttributes } from "react";
import { t } from "../i18n";
import { useHistory } from "react-router";
import { setModalPath } from "../onboardingpage/modalview/utils";
import { PATH } from "../onboardingpage/modalview/UserModalController";
import { UserLoginPrincipal } from "../http/protocol";
import { useDispatch } from "react-redux";
import { setTempUser } from "../user/UserActions";

interface MetamapButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isValid: boolean;
  values: any
}


export default function MetamapButton({ onClick, isValid, values, ...props }: MetamapButtonProps) {
  const history = useHistory();
  const dispatch = useDispatch();
  const transformFormValues = (values: Record<string, any>) => {
    const keys = Object.keys(values);
    let principalType = { field: "", principal: UserLoginPrincipal.EMAIL };
    
    if (keys.includes("email") && values['email']) {
      principalType.field = "email"
      principalType.principal = UserLoginPrincipal.EMAIL
    } else if (keys.includes("phoneNumber")) {
      principalType.field = "phoneNumber"
      principalType.principal = UserLoginPrincipal.PHONE_NUMBER
    }

    return {
      attributes: {},
      [principalType.field]: principalType.field === "phoneNumber" && values["phoneNumber"] ? `+${values[principalType.field]}` : values[principalType.field],
      password: values.password,
      principal: principalType.principal,
    };
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    console.log("MetamapButton handleClick called", transformFormValues(values));
    dispatch(setTempUser(transformFormValues(values) as any))
    setModalPath({ path: { type: PATH.KYC, modal: PATH.MODAL_TYPE }, history })
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button disabled={isValid} {...props} onClick={handleClick}>
      {t("forms.submit")}
    </button>
  );
}